export default "__VITE_ASSET__e2f03e22__"